// This file exports customized blocks for CDO Blockly labs.

import {blocks as spritelabBlocks} from './spritelabBlocks';

export default {
  ...spritelabBlocks,
};
